import { pause } from '../helpers/pause';

export async function retry<T>(retries: number, delay = 500, fn: () => Promise<T>): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    if (retries > 1) {
      await pause(delay);
      return retry(retries - 1, delay, fn);
    }
    throw e;
  }
}
